import './AutoCenter.less'
import AutoCenter from './AutoCenter'

export type { AutoCenterProps } from './AutoCenter'

export default AutoCenter
